import { HTTPInstance } from "@http/http-instance";

export type PaymentMethod = "full" | "split" | "items" | "custom";

export interface CreatePaymentPayload {
  method: PaymentMethod;
  orderDishIds?: string[];
  /**
   * The bill portion in grosze, WITHOUT the tip. The backend charges
   * `amount + tipAmount`, so folding the tip in here would take it twice.
   */
  amount?: number;
  numberOfPeopleToPayFor?: number;
  /** The tip in grosze. Recorded as a tip rather than as part of the bill. */
  tipAmount?: number;
  /**
   * Who the tip is for. Left out, the backend books it against whoever the
   * payment resolves to, so the venue still receives it.
   */
  userToTip?: string;
}

/** What the backend answers with: the Viva order the guest must now pay. */
export interface CreatedPayment {
  orderCode: string;
}

export const createPayment = async (
  tableId: string,
  payload: CreatePaymentPayload,
): Promise<CreatedPayment> => {
  const { data } = await HTTPInstance.post<{ orderCode: string | number }>(
    `/payments/tables/${tableId}`,
    payload,
  );
  // Viva's order codes are numeric and the backend passes the value through
  // untouched, so it arrives as a number and has to be a string in a URL.
  return { orderCode: String(data?.orderCode ?? "") };
};
